import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Lock, Zap, Users } from 'lucide-react';
export function OpeningLead() {
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) cta.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <section className="min-h-screen flex flex-col justify-center items-center px-6 pt-32 pb-20 max-w-[720px] mx-auto text-center md:text-left" data-id="element-227">
      <motion.div variants={container} initial="hidden" animate="show" className="space-y-10 w-full" data-id="element-228">
        <motion.div variants={item} className="space-y-4 text-center" data-id="element-229">
          <motion.div animate={{
          scale: [1, 1.03, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-flex items-center gap-2 bg-[var(--red-emphasis)]/15 border border-[var(--red-emphasis)]/40 text-[var(--red-emphasis)] text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-2" data-id="element-230">
            <Zap className="w-3 h-3 fill-current" data-id="element-231" />
            Precio especial de lanzamiento — Solo por tiempo limitado
          </motion.div>

          <p className="text-[var(--accent)] text-sm font-bold tracking-[0.2em] uppercase" data-id="element-232">
            Para el católico agotado que sigue creyendo
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[var(--text-heading)] leading-[1.15]" data-id="element-233">
            Cuando el cielo calla y <br className="hidden md:block" data-id="element-234" />
            <span className="text-[var(--accent)] italic" data-id="element-235">el dolor grita.</span>
          </h1>
          <p className="text-xl md:text-2xl text-[var(--text-muted)] font-serif italic mt-4" data-id="element-236">
            40 días para volver a respirar.
          </p>
        </motion.div>

        <motion.div variants={item} className="w-full py-6 flex justify-center" data-id="element-237">
          <div className="relative group cursor-pointer" onClick={scrollToCTA} data-id="element-238">
            {/* Multi-layer glow effect */}
            <div className="absolute inset-0 bg-[var(--accent)] blur-[80px] opacity-30 rounded-full group-hover:opacity-50 transition-opacity duration-700 scale-110" data-id="element-239"></div>
            <div className="absolute inset-0 bg-blue-400 blur-[40px] opacity-10 rounded-full group-hover:opacity-20 transition-opacity duration-700" data-id="element-240"></div>
            <img src="https://cdn.magicpatterns.com/uploads/m2Nc5dQ243QcHZ1mxcHfG1/ebook_cover.png" alt="Cuando Dios es lo único que te queda" className="relative z-10 w-64 md:w-80 rounded-lg shadow-[0_0_60px_rgba(201,168,76,0.3)] border border-[var(--accent)]/30 hover:scale-105 hover:shadow-[0_0_80px_rgba(201,168,76,0.5)] transition-all duration-500" data-id="element-241" />
          </div>
        </motion.div>

        <motion.div variants={item} className="space-y-6 text-lg md:text-xl text-[var(--text-primary)] leading-relaxed font-light" data-id="element-242">
          <p data-id="element-243">
            <span className="text-[var(--accent)] text-4xl float-left mr-2 font-serif leading-none" data-id="element-244">
              H
            </span>
            ay un momento que nadie te enseña a manejar.
          </p>
          <p data-id="element-245">
            Es ese instante en que te despiertas y lo primero que sientes no es
            esperanza, sino{' '}
            <strong className="font-medium text-[var(--text-heading)]" data-id="element-246">
              ese nudo en el estómago
            </strong>{' '}
            que ya lleva semanas instalado.
          </p>
          <p data-id="element-247">
            Te levantas. Miras al techo. Y en silencio —porque ya no tienes ni
            fuerzas para gritar— le preguntas a Dios:
          </p>
          <p className="font-serif italic text-[var(--text-heading)] text-xl pl-6 border-l-2 border-[var(--accent)] py-2 my-6" data-id="element-248">
            "¿Dónde estás? ¿Por qué me dejaste solo en esto?"
          </p>
          <p data-id="element-249">
            Tal vez es un diagnóstico que cambió todo en una tarde. Tal vez es
            una silla vacía en la mesa. Tal vez es una deuda, una traición, una
            pérdida que no tiene nombre pero pesa como si lo tuviera.
          </p>
        </motion.div>

        <motion.div variants={item} className="pt-8 text-center space-y-4" data-id="element-250">
          <motion.button onClick={scrollToCTA} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} animate={{
          boxShadow: ['0 0 0 0 rgba(201,168,76,0)', '0 0 35px 8px rgba(201,168,76,0.35)', '0 0 0 0 rgba(201,168,76,0)']
        }} transition={{
          boxShadow: {
            duration: 2.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="relative w-full md:w-auto px-12 py-5 bg-gradient-to-r from-[var(--accent)] to-[#dfc06a] text-[#110608] font-extrabold text-lg rounded-lg shadow-lg overflow-hidden group mx-auto flex items-center justify-center gap-3" data-id="element-251">
            <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/25 to-transparent" data-id="element-252" />
            <BookOpen className="w-5 h-5 relative z-10" data-id="element-253" />
            <span className="relative z-10 uppercase tracking-wide" data-id="element-254">
              → QUIERO EMPEZAR MI DÍA 1 AHORA
            </span>
          </motion.button>

          <div className="flex items-center justify-center gap-2 text-sm text-[var(--text-muted)]" data-id="element-255">
            <Users className="w-4 h-4 text-[var(--accent)]" data-id="element-256" />
            <span data-id="element-257">✅ +847 personas ya comenzaron su Día 1</span>
          </div>

          <p className="text-xs text-[var(--text-muted)] tracking-wider uppercase flex items-center justify-center gap-3" data-id="element-258">
            <Lock className="w-3 h-3" data-id="element-259" />
            Lectura digital inmediata • Garantía 7 días • Acceso de por vida
          </p>
        </motion.div>
      </motion.div>
    </section>;
}